<template>
	<v-dialog
		v-model="dialog"
		persistent
		transition="slide-x-reverse-transition"
	>
		<v-card flat>
			<v-dialog eager width="800" v-model="showMap">
				<v-card>
					<v-card-title>
						{{$t('Customers.add-location')}}
					</v-card-title>
					<v-card-text>
						<v-card height="400">
							<Map
								v-if="showMap"
								:points.sync="map"
								:center.sync="map[0]"
								@click-map="data => map = [{ lat: data.lat, lng: data.lng }]"
							></Map>
						</v-card>
					</v-card-text>

					<v-card-actions>
						<v-spacer />
						<v-btn
							color="success white--text"
							text
							@click="saveMapLocation"
						>
							{{$t('save')}}
						</v-btn>
						<v-btn
							text
							@click="closeMapDialog"
						>
							{{$t('close')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!-- title -->
			<v-toolbar
				dark
				flat
				:color="isDeletionRequest ? 'red lighten-1' : 'primary'"
				class="text-uppercase"
			>
				<v-spacer/>
				{{title}}
				<v-spacer/>
				<v-toolbar-items text samll>
					<v-btn small text @click="dialog=false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar-items>
			</v-toolbar>

			<v-form @submit.prevent="submit" ref="form">
				<!-- card content -->
				<v-card-text class="py-0">
					<v-container fluid>
						<v-row dense>
							<v-col cols="12" class="d-flex align-center">
								<v-chip-group
									v-if="id === null && customersTypes.length"
									v-model="dirType"
									show-arrows
									center-active
									active-class="success"
									mandatory
									class="mx-1"
									@change="reset"
								>
									<v-chip
										v-for="(type, index) in customersTypes"
										:key="index"
										:value="type.id"
										class="rounded-xl"
									>
										{{ type.name }}
									</v-chip>
								</v-chip-group>
							</v-col>

							<!-- name -->
							<v-col md="6" cols="12" class="d-flex align-center">
								<v-text-field
									v-model="name"
									:label="$T('inputs.name')"
									prepend-icon="mdi-account"
									dense
									:disabled="loading || isDeletionRequest"
									:rules="rules.required"
									required
								></v-text-field>

								<!-- matched entities -->
								<v-menu
									v-if="matchedEntities.length"
									offset-y
									:close-on-content-click="false"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											color="red"
											class="ms-1"
											v-on="on"
											v-bind="attrs"
										>
											<v-icon>mdi-information</v-icon>
										</v-btn>
									</template>

									<!-- matched entities list -->
									<v-list dense>
										<v-subheader
											class="justify-center"
											:style="{ height: '30px' }"
										>
											{{$T('messages.matched-entities')}}
										</v-subheader>
										<v-list-item
											v-for="item in matchedEntities"
											:key="item.id"
											v-on="
												isAddingDirectly
												? {
													click: () => {
														$emit('match-selected', item.id);
														dialog = false;
													}
												}
												: null
											"
										>
											<v-list-item-icon class="me-2">
												<v-icon dense>mdi-account</v-icon>
											</v-list-item-icon>
											<v-list-item-title>
												{{item.name}}
											</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-col>

							<!-- specialty -->
							<!-- v-if="customersConfig?.CustomerSpeciality" -->
              <!-- {{ customersConfig }} -->
							<v-col
								md="6"
								cols="12"
							>
								<v-autocomplete
									v-model="specialtyId"
									:items="specialties"
									:label="$T('inputs.specialty')"
									item-text="name"
									item-value="id"
									prepend-icon="mdi-account"
									dense
									:disabled="loading || isDeletionRequest"
									:rules="rules.required"
									required
								></v-autocomplete>
							</v-col>
							<!-- ------------------------------------------------------------------------------------- -->
							<!-- ------------------------------------------------------------------------------------- -->
							<!-- ------------------------------------------------------------------------------------- -->
							<!-- ------------------------------------------------------------------------------------- -->
							<!-- new fields -->
							<v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.Loyality : true">
                                <v-autocomplete
                                    v-model="loyality"
                                    :items="loyalty"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.loyalty')"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.Relegion : true">
                                <v-autocomplete
                                    v-model="religion"
                                    :items="religions"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.religion')"
									prepend-icon="mdi-star-crescent"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.Personality : true">
                                <v-autocomplete
                                    v-model="personality"
                                    :items="personalityArray"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.personality')"
									prepend-icon="mdi-badge-account-outline"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.CustomerBirthdate : true">
								<v-menu
									ref="menu"
									v-model="menu"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="auto"
									:disabled="loading"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="birthdate"
											:label="$T('inputs.birthdate')"
											prepend-icon="mdi-calendar"
											readonly
											v-bind="attrs"
											v-on="on"
											dense
											:disabled="loading"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="birthdate"
										:max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000 * 170)).toISOString().substr(0, 10)"
										min="2005-01-01"
										@change="save"
									></v-date-picker>
                            </v-menu>
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.Weekend : true">
                                <v-autocomplete
                                    v-model="weekend"
                                    :items="daysOfWeek"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.weekend')"
                                    multiple
									prepend-icon="mdi-calendar-weekend"
                                />
                            </v-col>
							<!-- customerTypeConfig?.NearbyMarkets -->
                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.NearbyPointOfSale : true">
                                <v-text-field
                                    v-model="nearbyPharmaciesOne"
                                    dense
                                    :label="$t('inputs.nearby-pharmacy-1')"
                                />
                            </v-col>

							<!-- customerTypeConfig?.NearbyMarkets -->
                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.NearbyPointOfSale : true">
                                <v-text-field
                                    v-model="nearbyPharmaciesTwo"
                                    dense
                                    :label="$t('inputs.nearby-pharmacy-2')"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.WorksInAnotherCenter : true">
                                <v-text-field
                                    v-model="worksInCenters"
                                    dense
                                    :label="$t('inputs.works-in-centers')"
                                />
                            </v-col>
                            <v-col md="6" cols="12"  v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.WorkHourFrom : true">
                                <v-text-field
                                    v-model="workHourFrom"
                                    dense
                                    :label="$t('inputs.work-hours-from')"
                                    type="time"
									prepend-icon="mdi-timer-sand"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.WorkHourTo : true">
                                <v-text-field
                                    v-model="workHourTo"
                                    dense
                                    :label="$t('inputs.work-hours-to')"
                                    type="time"
									prepend-icon="mdi-timer-sand-complete"
                                />
                            </v-col>
                        </v-row>

                        <v-row dense class="mt-0">
                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.ResidentEmployeesNames : false">
                                <v-textarea
                                    v-model="doctorNames"
                                    :label="$t('inputs.resident-doctors')"
                                    clearable
                                    dense
                                    rows="1"
                                    :auto-grow="true"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.Hobbies : true" class="py-1 ">
                                <v-textarea
                                    v-model="doctorHobbies"
                                    dense
                                    :label="$t('inputs.doctor-hobbies')"
                                    rows="1"
                                    :auto-grow="true"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.PersonalNotes : true" class="py-1">
                                <v-textarea
                                    v-model="personalNote"
                                    dense
                                    :label="$t('inputs.personal-note')"
                                    rows="1"
                                    :auto-grow="true"
                                />
                            </v-col>

							<!-- pharmacistInfoShow -->
                            <v-col v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.OwnerInfo : true" cols="4">
                                <v-text-field
                                    v-model="pharmacistInfo"
                                    dense
                                    :label="$t('inputs.pharmacist-info')"
                                    hide-details
                                />
                            </v-col>

                            <v-col v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.CustomerInfo : true" md="6" cols="12" class="py-1 ">
                                <v-textarea
                                    v-model="pharmacyInfo"
                                    dense
                                    :label="$t('inputs.pharmacy-info')"
                                    rows="-1"
                                    :auto-grow="true"
                                />
                            </v-col>

                            <v-col md="6" cols="12" v-if="configIsEmpty(customerTypeConfig) === false ? customerTypeConfig?.CustomerVisitNotes : true" class="py-1">
                                <v-textarea
                                    v-model="visitNotes"
                                    dense
                                    :label="$t('inputs.visit-notes')"
                                    rows="1"
                                    :auto-grow="true"
									prepend-icon="mdi-message-bulleted"
                                />
                            </v-col>

							<!-- ------------------------------------------------------------------------------------- -->
							<!-- ------------------------------------------------------------------------------------- -->
							<!-- ------------------------------------------------------------------------------------- -->
							<!-- ------------------------------------------------------------------------------------- -->
							<!-- ------------------------------------------------------------------------------------- -->

							<!-- addresses -->
							<v-col v-if="configIsEmpty(customersConfig) === false ? customersConfig?.CustomerAddress : true" cols="12">
								<div class="d-flex flex-grow-1 justify-space-between align-center">
									<div class="d-flex align-center">
										<span class="text-body-1">{{$t('Customers.addresses')}}</span>
									</div>

									<v-btn text small @click="addAddress" v-if="!isDeletionRequest">
										<v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</div>

								<!-- address card -->
								<v-row
									v-for="(address, index) in addresses"
									:key="address.id"
									class="align-center"
									dense
								>
									<v-col cols>
										<!-- address card -->
										<v-card class="mt-4">
											<v-card-text>
												<v-row dense>
													<!-- region -->
													<v-col cols="4">
														<v-autocomplete
															v-model="address.data.regionId"
															:items="regions"
															item-text="name"
															item-value="id"
															:label="$T('inputs.region')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-autocomplete>
													</v-col>

													<!-- workload -->
													<v-col cols="4">
														<v-autocomplete
															v-model="address.data.workloadId"
															:items="workloads"
															item-text="name"
															item-value="id"
															:label="$T('inputs.workload')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-autocomplete>
													</v-col>

													<v-spacer />

													<v-col v-if="allowAddOnMap" :text="$t('Customers.add-location')" top class="d-flex justify-end">
														<v-btn
															icon
															small
															color="success"
															@click="openMapDialog(index)"
														>
															<v-icon>
																mdi-map-marker
															</v-icon>
														</v-btn>
													</v-col>

													<!-- bestTimeToVisit -->
													<v-col v-if="configIsEmpty(customersConfig) === false ? customersConfig?.BestTimeToVisit : true" cols="4">
														<v-text-field
															v-model="address.data.bestTimeToVisit"
															:label="$T('inputs.best-time-to-visit')"
															dense
															:disabled="loading || isDeletionRequest"
															required
														/>
													</v-col>

													<!-- address -->
													<v-col cols="12">
														<v-text-field
															v-model="address.data.address"
															:label="$T('inputs.address')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-text-field>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>

									<!-- remove button -->
									<v-col cols="1" class="pa-0" v-if="!isDeletionRequest">
										<v-btn text small @click="removeAddress(address.id)">
											<v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>

							<!-- contactInfos -->
							<v-col v-if="configIsEmpty(customersConfig) === false ? customersConfig?.ContactInfo : true" cols="12">
								<div class="d-flex flex-grow-1 justify-space-between align-center">
									<div class="d-flex align-center">
										<span class="text-body-1">{{$t('Customers.contact-information')}}</span>
									</div>

									<v-btn text small @click="addContact" v-if="!isDeletionRequest">
										<v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</div>

								<!-- contactInfos card -->
								<v-row
									v-for="contactInfo in contactInfos"
									:key="contactInfo.id"
									class="align-center"
								>
									<v-col cols>
										<!-- contactInfos card -->
										<v-card class="mt-4">
											<v-card-text>
												<v-row>
													<!-- Contact Type -->
													<v-col cols="6">
														<v-autocomplete
															v-model.number="contactInfo.data.contactInfoType"
															:items="contactInfoTypes"
															item-text="name"
															item-value="id"
															:label="$T('inputs.contact-type')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.requiredAsNumber"
															required
														></v-autocomplete>
													</v-col>

													<!-- contact Label -->
													<v-col cols="6">
														<v-text-field
															v-model="contactInfo.data.value"
															:label="contactInfo.data.contactInfoType !== null ? getContactLabel(contactInfo.data.contactInfoType) : $T('inputs.contact')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-text-field>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>

									<!-- remove button -->
									<v-col cols="2" class="pa-0" v-if="!isDeletionRequest">
										<v-btn text small @click="removeContact(contactInfo.id)">
											<v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>

							<!-- reason -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model="reason"
									:label="$T('inputs.reason')"
									dense
									:disabled="loading"
									:rules="rules.required"
									required
								></v-text-field>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<v-spacer/>

				<v-card-actions>
					<v-spacer/>
					<v-btn
						:color="isDeletionRequest ? 'red lighten-1' : 'success'"
						text
						type="submit"
						:loading="loading"
						:disabled="loading"
					>
						{{$T('send')}}
					</v-btn>
					<v-btn color="grey darken-1" text @click="dialog = false" :disabled="loading">
						{{$T('close')}}
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from '@/helpers/validation rules'
import { mapState, mapGetters } from 'vuex'
import { deletionExternal } from '@/configs/general.configs'
import { loyalty, religions, personalityArray } from '@/helpers/enums'
import Map from '@/components/Map.vue'
export default {
	components: {
		Map
	},

	data(vm) {
		return {
			loyalty,
			religions,
			// helpers
			id: null,
			entity: null,
			dialog: false,

			title: null,

			loading: false,
			rules,

			isDeletionRequest: false,

			contactInfoTypes: [
				{ id: 0, name: vm.$t('Customers.contactInfoTypes.phone') },
				{ id: 1, name: vm.$t('Customers.contactInfoTypes.landline') },
				{ id: 2, name: vm.$t('Customers.contactInfoTypes.email') },
				{ id: 3, name: vm.$t('Customers.contactInfoTypes.facebook') },
				{ id: 4, name: vm.$t('Customers.contactInfoTypes.twitter') },
				{ id: 5, name: vm.$t('Customers.contactInfoTypes.whatsApp') },
				{ id: 6, name: vm.$t('Customers.contactInfoTypes.telegram') },
				{ id: 7, name: vm.$t('Customers.contactInfoTypes.linkedIn') },
				{ id: 8, name: vm.$t('Customers.contactInfoTypes.website') },
			],

			dirType: null,

			addresses: [],
			addressesCounter: 0,
			contactInfos: [],
			contactCounter: 0,

			// search input
			isTyping: false,
			finalSearchInput: false,
			matchedEntities: [],
			isAddingDirectly: false,

			// data
			name: null,
			reason: null,
			specialtyId: null,
			loyality: null,
			religion: null,
			personality: null,
			birthdate: null,
			weekend: [],
			workHourFrom: null,
			workHourTo: null,
			nearbyPharmaciesOne: null,
			nearbyPharmaciesTwo: null,
			worksInCenters: null,
			doctorNames: null,
			doctorHobbies: null,
			personalNote: null,
			pharmacyInfo: null,
			visitNotes: null,
			daysOfWeek: [
				'Sat',
				'Sun',
				'Mon',
				'Tue',
				'Wed',
				'Thu',
				'Fri'
			],
			menu: false,
			deletionExternal,
			personalityArray,
			map: [],
			showMap: false,
			editAddressRowIndex: null,
			pharmacistInfo: null
		}
	},

	watch: {
		name(val) {
			if (!this.id) {
				this.isTyping = true;
				this.finalSearchInput = val;
				this.matchedEntities = [];
				setTimeout(() => {
					if (this.finalSearchInput === val) this.isTyping = false;

					if (!this.isTyping && this.name) {
						this.$store.dispatch('entities/fetchMatchedEntities', {
							name: this.name,
							regionId: this.regionId
						}).then(data => {
							this.matchedEntities = data;
						});
					}
				}, 500)
			}
		},

		dialog(val) {
			if (!val) {
				this.isAddingDirectly = false;
			} else if (val && !this.customersTypes.length) {
				this.$store.dispatch('entities/fetchEntityType').then(() => {
					this.dirType = this.customersTypes[0]?.id
				});
			} else if (this.customersTypes.length) {
				this.dirType = this.customersTypes[0]?.id
			}

			if (val) {
				this.ensureLocationPermissionOnDialogOpen()
			}
		},

		showMap (val) {
			if (val) {
				this.setCurrentDeviceLocationOnMap()
			}
		}
	},

	methods: {
		requestCurrentDeviceLocation({ onSuccess, onError, notifyOnError = false } = {}) {
			if (!navigator.geolocation) {
				if (notifyOnError) {
					this.$eventBus.$emit('show-snackbar', 'Location service is not available on this device', 'info')
				}

				if (onError) onError()
				return
			}

			navigator.geolocation.getCurrentPosition(
				(position) => {
					if (onSuccess) {
						onSuccess({
							lat: position.coords.latitude,
							lng: position.coords.longitude
						})
					}
				},
				() => {
					if (notifyOnError) {
						this.$eventBus.$emit('show-snackbar', 'Please allow location access to use the map accurately', 'info')
					}

					if (onError) onError()
				},
				{
					enableHighAccuracy: true,
					timeout: 10000,
					maximumAge: 0
				}
			)
		},

		ensureLocationPermissionOnDialogOpen() {
			if (!this.allowAddOnMap) return

			this.requestCurrentDeviceLocation({
				onSuccess: () => {},
				onError: () => {},
				notifyOnError: true
			})
		},

		setCurrentDeviceLocationOnMap() {
			const addressCoordinates = this.getCurrentAddressCoordinates()

			this.requestCurrentDeviceLocation({
				onSuccess: (coordinates) => {
					this.map = [coordinates]
				},
				onError: () => {
					if (addressCoordinates) {
						this.map = [addressCoordinates]
					}
				},
				notifyOnError: true
			})
		},

		openMapDialog(rowIndex) {
			this.editAddressRowIndex = rowIndex
			this.showMap = true
		},

		saveMapLocation() {
			if (
				this.map.length &&
				this.editAddressRowIndex !== null &&
				this.addresses[this.editAddressRowIndex]
			) {
				const selectedPoint = this.map[0]
				this.addresses[this.editAddressRowIndex].data.latitude = selectedPoint.lat
				this.addresses[this.editAddressRowIndex].data.longitude = selectedPoint.lng
			}

			this.showMap = false
		},

		closeMapDialog() {
			this.showMap = false
		},

		getCurrentAddressCoordinates() {
			if (this.editAddressRowIndex !== null) {
				const currentAddress = this.addresses[this.editAddressRowIndex]
				const lat = Number(currentAddress?.data?.latitude)
				const lng = Number(currentAddress?.data?.longitude)

				if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
					return { lat, lng }
				}
			}

			const firstAddressWithCoordinates = this.addresses.find((address) => {
				const lat = Number(address?.data?.latitude)
				const lng = Number(address?.data?.longitude)
				return !Number.isNaN(lat) && !Number.isNaN(lng)
			})

			if (firstAddressWithCoordinates) {
				return {
					lat: Number(firstAddressWithCoordinates.data.latitude),
					lng: Number(firstAddressWithCoordinates.data.longitude)
				}
			}

			return null
		},

		reset() {
			if (this.name) {
				this.$refs.form.resetValidation();
			};

			this.id = null;
			this.addresses = [];
			this.addressesCounter = 0;
			this.contactInfos = [];
			this.contactCounter = 0;
			this.isDeletionRequest = false;

			this.name = null;
			this.reason = null;
			this.specialtyId = null;
			this.loyality = null
			this.religion = null
			this.personality = null
			this.birthdate = null
			this.weekend = []
			this.personalNote = null
			this.pharmacistInfo = null
			this.doctorHobbies = null
			this.nearbyPharmaciesOne = null
			this.nearbyPharmaciesTwo = null
			this.visitNotes = null
			this.worksInCenters = null
			this.workHourTo = null
			this.workHourFrom = null
			this.pharmacistInfo = null
			this.pharmacyInfo = null
			this.map = []
			this.showMap = false
			this.editAddressRowIndex = null
		},

		// addresses
		addAddress() {
			if (this.customersTypes.find(c => c.id === this.dirType)?.name !== 'Doctors' && this.addressesCounter < 1) {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: null,
							workloadId: null,
							address: null,
							latitude: null,
							longitude: null
							// bestTimeToVisit: null
						}
					}
				);
			} else if (this.customersTypes.find(c => c.id === this.dirType)?.name === 'Doctors') {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: null,
							workloadId: null,
							address: null,
							latitude: null,
							longitude: null
							// bestTimeToVisit: null
						}
					}
				);
			} else {
				const message = this.$T('messages.one-address-for-pharmacies-and-centers');
				this.$eventBus.$emit('show-snackbar', message, 'info');
			}
		},

		removeAddress(index) {
			this.addresses.splice(index, 1);
			this.addresses.forEach(item => {
				if (item.id > index) item.id--;
			});
			this.addressesCounter--;
		},

		// contact infos
		addContact() {
			this.contactInfos.push(
				{
					id: this.contactCounter++,
					data: {
						contactInfoType: null,
						value: null,
					}
				}
			);
		},

		removeContact(index) {
			this.contactInfos.splice(index, 1);
			this.contactInfos.forEach(item => {
				if (item.id > index) item.id--;
			});
			this.contactCounter--;
		},

		getContactLabel(contactId) {
			return this.contactInfoTypes.find(contact => contact.id === contactId).name;
		},

		// dialog functions
		addCustomer(initData = null) {
			if (!this.customersTypes.length) {
				this.$eventBus.$emit('show-snackbar', this.$t('Customers.no-customer-types-to-add'), 'info');
				return;
			}

			this.reset();
			// this.dirType = 1;
			this.title = this.$t('Customers.creation-customer-request');
			this.dialog = true;

			if (initData) {
				this.isAddingDirectly = true;
				this.name = initData.name;
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: initData.regionId,
							workloadId: null,
							address: null,
							latitude: null,
							longitude: null
							// bestTimeToVisit: null
						}
					}
				);
			}
		},

		editCustomer(id) {
			this.reset();
			this.id = id;
			this.fillData();
			this.title = this.$t('Customers.modification-customer-request');
			this.dialog = true;
		},

		deleteCustomer(id) {
			this.reset();
			this.id = id;
			this.fillData();
			this.isDeletionRequest = true;
			this.title = this.$t('Customers.deletion-customer-request');
			this.dialog = true;
		},

		fillData() {
			this.entity = this.getEntityById(this.id);

			this.name = this.entity.name;

			this.specialtyId = this.entity.specialtyIds[0];

			this.dirType = this.entity.entityTypeId;

			this.loyality = this.entity.loyality;
			this.religion = this.entity.relegion;
			this.personality = this.entity.personality;
			this.birthdate = this.entity.birthdate ? this.entity.birthdate.substr(0, 10) : null;
			this.weekend = this.entity.weekend ? this.entity.weekend.split(',').map(day => day.trim()) : [];
			this.workHourFrom = this.entity.workHourFrom;
			this.workHourTo = this.entity.workHourTo;
			this.worksInCenters = this.entity.worksInCenters;
			this.doctorNames = this.entity.residentDoctorNames;
			this.doctorHobbies = this.entity.hobbies;
			this.personalNote = this.entity.personalNote;
			this.visitNotes = this.entity.visitNotes;
			this.pharmacistInfo = this.entity.customerInfo;
			this.pharmacyInfo = this.entity.ownerInfo;

			const nearbyPointOfSales = this.entity.nearbyPointOfSales ? this.entity.nearbyPointOfSales.split(',') : [];
			this.nearbyPharmaciesOne = nearbyPointOfSales[0] || null;
			this.nearbyPharmaciesTwo = nearbyPointOfSales[1] || null;

			this.entity.entityAddresses.forEach(address => {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: address.regionId,
							workloadId: address.workloadId,
							address: address.address,
							latitude: address.latitude,
							longitude: address.longitude
							// bestTimeToVisit: null
						}
					}
				);
			})

			this.entity.contactInfos.forEach(contactInfo => {
				this.contactInfos.push(
					{
						id: this.contactCounter++,
						data: {
							contactInfoType: contactInfo.contactInfoType,
							value: contactInfo.value,
						}
					}
				);
			})
		},

		getAddressesPayload() {
			return this.addresses.map(({ data }) => ({
				...data,
				latitude: data.latitude !== null && data.latitude !== undefined && data.latitude !== ''
					? String(data.latitude)
					: null,
				longitude: data.longitude !== null && data.longitude !== undefined && data.longitude !== ''
					? String(data.longitude)
					: null,
			}))
		},

		submit() {
			if (this.$refs.form.validate()) {
				if (!this.addresses.length) {
					this.$eventBus.$emit(
						'show-snackbar',
						this.$t('validation-messages.one-address-at-least'),
						'info'
					)
					return;
				}

				this.loading = true;
				console.log('!this.enableAddingCustomersDirectly && !this.isDeletionRequest', !this.enableAddingCustomersDirectly && !this.isDeletionRequest)
				const actionName =
					this.enableAddingCustomersDirectly && !this.isDeletionRequest ? 'directModify' : 'modify';

				// Deletion / modification customer request
				if (this.id) {
					this.$store.dispatch('entities/modify', {
						// requestType = 1 modification, 2 Deletion
						entityType: 0,
						requestType: this.isDeletionRequest ? 2 : 1,
						entityId: this.entity.id,
						typeId: this.dirType,
						name: this.name,
						reason: this.reason,
						specialtyId: this.specialtyId,
						entityAddresses: this.getAddressesPayload(),
						contactInfos: this.contactInfos.map(c => c.data),
						loyality: this.loyality,
						relegion: this.religion,
						personality: this.personality,
						birthdate: this.birthdate,
						weekend: this.weekend.length ? this.weekend.join(', ') : null,
						personalNote: this.personalNote,
						customerInfo: this.pharmacistInfo,
						hobbies: this.doctorHobbies,
						nearbyPointOfSales: this.nearbyPharmaciesOne || this.nearbyPharmaciesTwo ? this.nearbyPharmaciesOne + ',' + this.nearbyPharmaciesTwo : null,
						// visitNotes: this.doctorData.visitNotes ? this.doctorData.visitNotes : null,
						visitNotes:	this.visitNotes,
						worksInCenters:	this.worksInCenters,
						pmWorkHour:	this.workHourTo,
						amWorkHour: this.workHourFrom,
						ownerInfo: this.pharmacyInfo,
						residentDoctorNames: this.doctorNames
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Customers.the-request-is-sent'));
							this.dialog = false;
							if (this.enableAddingCustomersDirectly && !this.isDeletionRequest) { this.$emit('update-entities') }
						})
						.finally(() => {
							this.loading = false;
						})
				} else {
					// creation customer request
					this.$store.dispatch(`entities/${actionName}`, {
						// requestType = 0 creation
						requestType: 0,
						entityId: null,
						typeId: this.dirType,
						entityType: 0,
						name: this.name,
						reason: this.reason,
						specialtyId: this.specialtyId,
						entityAddresses: this.getAddressesPayload(),
						contactInfos: this.contactInfos.map(c => c.data),
						loyality: this.loyality,
						relegion: this.religion,
						personality: this.personality,
						birthdate: this.birthdate,
						weekend: this.weekend.length ? this.weekend.join(', ') : null,
						personalNote: this.personalNote,
						customerInfo: this.pharmacistInfo,
						hobbies: this.doctorHobbies,
						nearbyPointOfSales: this.nearbyPharmaciesOne || this.nearbyPharmaciesTwo ? this.nearbyPharmaciesOne + ',' + this.nearbyPharmaciesTwo : null,
						// visitNotes: this.doctorData.visitNotes ? this.doctorData.visitNotes : null,
						visitNotes:	this.visitNotes,
						worksInCenters:	this.worksInCenters,
						pmWorkHour:	this.workHourTo,
						amWorkHour: this.workHourFrom,
						ownerInfo: this.pharmacyInfo,
						residentDoctorNames: this.doctorNames
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Customers.the-request-is-sent'));
							this.dialog = false;
							if (this.enableAddingCustomersDirectly) { this.$emit('update-entities') }
						})
						.finally(() => {
							this.loading = false;
						})
				}
			}
		},

		save (date) {
			this.$refs.menu.save(date)
		},

		configIsEmpty (obj) {
			return obj ? Object.keys(obj).length === 0 : true
		}
	},

	computed: {
		...mapState({
			regions: state => state.regions.regions,
			entities: state => state.entities.entities,
			specialties: state => state.specialties.specialties,
			workloads: state => state.workloads.workloads,
			customersTypes: state => deletionExternal ? state.entities.customersTypes.filter(c => c.name !== 'Externals') : state.entities.customersTypes,
			customersConfig: state => state.configurations.configurations.customersConfig,
			customerType: state => state.configurations.customerType,
			allowAddOnMap: state => state.configurations.systemConfigValue.properties?.find(c => c.key === 'allowAddOnMap')?.value,
			enableAddingCustomersDirectly: state => state.configurations.systemConfigValue.properties?.find(c => c.key === 'AllowAddCustomer')?.value
		}),

		...mapGetters({
			getEntityById: 'entities/getEntityById'
		}),

		customerTypeConfig () {
			return (this.customersTypes.length && this.customersTypes.length > 0) ? this.customerType.find(c => c.key === this.dirType)?.data : {}
		},
	},

	mounted() {
		// this.$store.dispatch('configurations/fetchEnum').then(() => {
		// 	this.$store.dispatch('configurations/fetchAll')
		// })
		// this.$store.dispatch('configurations/fetchSystemConfigValue')

		this.$store.dispatch('entities/fetchEntityType').then(() => {
			this.$store.dispatch('configurations/fetchEnum').then(() => {
				this.$store.dispatch('configurations/fetchAll')
			})
		})
		this.$store.dispatch('configurations/fetchSystemConfigValue')
		if (!this.customersTypes.length) {
			this.$store.dispatch('entities/fetchEntityType');
		}
	}
}
</script>

<style>

</style>
